/**
 * Created by mark on 10/01/2018.
 */



import React from 'react';
import {Button} from 'react-bootstrap';
import Recorder from '../Recorder.js'
import Config from '../classes/config.js';
import Translation from '../store/internationalization-store.js';


export default class RecorderUpload extends React.Component {

    constructor(props){
        super(props);
        this.props = props;
        this.state = {command:'stop' , recording:false , audioPreview:null,baseFile:props.baseFile }
    }

    componentWillReceiveProps(props){

        if(!props.recorded)
        {
            this.setState({
                audioPreview: props.audioPreview || null,
                baseFile:props.baseFile
            });
        } else {
            this.setState({
                baseFile:props.baseFile
            });
        }

    }

    onStop(blob){

        let reader = new FileReader();
        let file   = blob;

        reader.onloadend = () => {
            this.setState({
                file: file,
                audioPreview: reader.result
            });

          //  this.props.onChange(reader.result);
        };

        if (file != undefined) {
            reader.readAsDataURL(file)
        }
    }

    onStart(){
        console.log('start')
    }


    onSave()
    {
        if(!this.state.audioPreview) return;
        if(this.props.onSave) this.props.onSave(this.state.audioPreview);
        this.props.onHide();
    }

    handelPreviewPlay(src){
        if(!this.state.audioPreview) return;
        this.audio = new Audio(src);
        this.audio.play();
    }

    toggleRecording(){

        let recording = !this.state.recording;
        this.setState({
            command : recording ? 'start' : 'stop',
            recording : recording
        });
    }

    render(){

        let  playButton = <Button disabled={!this.state.audioPreview} onClick={this.handelPreviewPlay.bind(this , this.state.audioPreview)} className={!this.state.audioPreview ? '' : ''} >{Translation.get(12687, 'Audio playback')}</Button>


        return <div>

            <button onClick={this.toggleRecording.bind(this)}  className={this.state.recording ? "btn btn-info btn-circle btn-xl btn-danger" : "btn btn-info btn-circle btn-xl" } class="btn btn-info btn-circle btn-xl">
                <i class="fas fa-microphone fa-2x"></i>
            </button>

            <center>{Translation.get(12688, "Press the button to start recording, and again when you are finished.")}</center>
            <br/>
            <table width={'100%'}>
                <tr>
                    <td>
                        <center>{playButton}&nbsp;&nbsp;<Button onClick={()=>{this.setState({preview:false})}} disabled={!this.state.audioPreview} onClick={this.onSave.bind(this)} className={!this.state.audioPreview ? '' : ''}>{Translation.get(12689, "Save Audio")}</Button></center>
                    </td>
                </tr>
            </table>
            <Recorder command={this.state.command} onStart={this.onStart.bind(this)}  onStop={this.onStop.bind(this)} />
        </div>
    }

}